<!-- 听评课 -->
<template>
    <div class="listen-lesson">
        <div class="listen-lesson-top">
            <div class="title">年级评价分析</div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="teaching-info">
            <div id="listenEchartsId" style="width: 100%;height: 100%;"></div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div> 
  </template>
  
  <script>
  import * as echarts from 'echarts';
  export default {
    name: 'listen-lesson',
    components: {
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
        phaseList:[
            {
                value:5500,
                name:'一年级',
                number:50
            },
            {
                value:500,
                name:'二年级',
                number:6
            },
            {
                value:500,
                name:'三年级',
                number:6
            },
            {
                value:500,
                name:'四年级',
                number:6
            },
            {
                value:500,
                name:'五年级',
                number:6
            },
            {
                value:500,
                name:'六年级',
                number:6
            },
            {
                value:500,
                name:'七年级',
                number:6
            },
            {
                value:500,
                name:'八年级',
                number:6
            },
            {
                value:500,
                name:'九年级',
                number:6
            },
            {
                value:500,
                name:'高一',
                number:6
            },
            {
                value:500,
                name:'高二',
                number:6
            },            {
                value:500,
                name:'高三',
                number:6
            },  
        ]
        }
    },
    methods: {
       
        initEcharts(){
            let dom = document.getElementById('listenEchartsId')
            let myChart = echarts.init(dom)
            let option;
            option = {
                tooltip: {
                    trigger: 'item',
                    // show: false,
                    // 数据的显示方式
                    formatter: (param) => {
                        return `${param.data.name}<br/>${param.data.value}个评价`
                    }
                },
                legend: {
                    selectedMode: false, // 是否允许点击
                    // top: 'bottom',
                    bottom: '5%',
                    left: '10%',
                    itemWidth: 9, //图例标记的图形宽度
                    itemHeight: 9,
                    itemGap: 10, //图例之间的间隙
                    textStyle: {
                        color: '#ffffff',
                        borderWidth: 2
                    },
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['50%', '40%'],
                        avoidLabelOverlap: false,
                        color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                        label: {
                            show: false,
                            position: 'center',
                            formatter: (data) => {
                                return (
                                "{a|" +
                                data.data.number +
                                "%}" +
                                "\r\n" +
                                "{b|" +
                                data.data.name +
                                "}"
                                );
                            },
                            rich: {
                                a: {
                                    fontSize: 16,
                                    lineHeight: 20,
                                    color: "#fff",
                                    align: "center",
                                    fontWeight: "bold",
                                },
                                b: {
                                    fontSize: 12,
                                    lineHeight: 16,
                                    fontWeight: "bold",
                                    color: "#7ABFDB",
                                    align: "center",
                                },
                            },
                            backgroundColor: "transparent",
                            fontWeight: "bold",
                            fontSize: "15",
                            padding: 6,
                        },
                        emphasis: {
                            label: {
                            show: true,
                            fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.phaseList
                    }
                ]
            };
            option && myChart.setOption(option)
        }
    },
    mounted(){
        this.initEcharts();
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .listen-lesson{
    width: 100%;
    height: 300px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .listen-lesson-top{
        position: relative;
        text-align: center;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .teaching-info{
        width: 100%;
        height: 260px;
        position: relative;
     
        
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
  }
  </style>
  <style lang="scss">
  </style>